
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conventions/[convention_id]/sessions/[session_id]",
      function () {
        return require("private-next-pages/conventions/[convention_id]/sessions/[session_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conventions/[convention_id]/sessions/[session_id]"])
      });
    }
  